// extracted by mini-css-extract-plugin
module.exports = {"familyMember":"member-operations__FamilyMembers__familyMember","spinner":"member-operations__FamilyMembers__spinner"};